::ng-deep a{color:var(--accent, #175CFF)}::ng-deep a:hover{text-decoration:none!important}
/*# sourceMappingURL=task-title.component-PVJPKOLB.css.map */
